import {Injectable} from '@angular/core';
import {MemberState} from '../modules/akita-mimic/models/store-states/member-state.model';
import {EntityStoreService} from '../modules/akita-mimic/services/entity-store.service';
import {VaultMember} from '../api/models/vault-member';

@Injectable({ providedIn: 'root' })
export class MemberStore extends EntityStoreService<MemberState, VaultMember> {
    public constructor() {
        super('member', {
            active: [],
            entities: {},
            ids: [],
            loading: false,
        });
    }
}
